import { call, put, takeLatest } from "redux-saga/effects";

import { PatientsAPI } from "../../../api/patientsAPI";
import {
  ADD_MEDICATION_REQUEST,
  ADD_MEDICATION_SUCCESS,
  ADD_MEDICATION_ERROR,
  SET_TOAST
} from "../../actions";
import {ToastType} from "../../../utils/interfaces";

function* workerAddMedication({
  type,
  payload: { medication, patientId },
}: {
  type: string;
  payload: {
    medication: any;
    patientId: any;
  };
}): Generator<any> {
  try {
    const data: any = yield call(PatientsAPI.addMedication, medication, patientId);

    yield put({
      type: ADD_MEDICATION_SUCCESS,
      payload: { defaultMedications: data }
    });
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Medication was added successfully",
        type: ToastType.SUCCESS,
      }
    });
  } catch (error: any) {
    yield put({
      type: ADD_MEDICATION_ERROR,
      payload: { code: error.response.status, message: error.message }
    });
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Something went wrong",
        type: ToastType.ERROR,
      }
    });
  }
}

export function* watcherAddMedication() {
  yield takeLatest(ADD_MEDICATION_REQUEST, workerAddMedication);
}
